import InfoBanner from './InfoBanner';
export * from './InfoBanner';
export default InfoBanner;
